export enum ErrorMessageType {
  Storage,
  Filesystem,
  Connection,
  NotSynced,
  Microphone,
  RecordingInterrupted,
  Unknown
}
